import ChipInspectionResultStatus from '@/components/chip/ChipInspectionResultStatus';
import type { StatusChipProps } from '@/components/chip/ChipTicketStatus';
import { InspectionResultEnum } from '@/types/enums/inspection-result.enum';
import { t } from '@/utils/lang';

export const getInspectionResultData = (props: StatusChipProps) => {
    return ChipInspectionResultStatus(props);
};

export const getInspectionResultOptionsFilter = (isFilter?: boolean) => {
    const enumValues = InspectionResultEnum;

    const options: any[] = [];

    Object.keys(enumValues).forEach(key => {
        const data = getInspectionResultData({
            status: enumValues[key],
            showChip: false,
        });

        options.push({
            id: enumValues[key],
            value: !isFilter ? enumValues[key] : key.toUpperCase(),
            title: data.label,
            label: t(data.label),
        });
    });

    return options;
};
